var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    fill: "none",
    viewBox: "0 0 55 55"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E9575F",
    d: "m30.708 27.5 9.855-9.854c.916-.917.916-2.292 0-3.209-.917-.916-2.292-.916-3.209 0L27.5 24.293l-9.854-9.855c-.917-.916-2.292-.916-3.209 0-.916.917-.916 2.292 0 3.209l9.855 9.854-9.855 9.854c-.916.917-.916 2.292 0 3.209.459.458.917.687 1.605.687s1.145-.23 1.604-.687l9.854-9.855 9.854 9.855c.459.458 1.146.687 1.604.687s1.146-.23 1.605-.687c.916-.917.916-2.292 0-3.209z"
  })));
};
export default SvgError;